import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Menu } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { CARD_LOCALE_KEY } from '../InvoiceMetricsSection.utils';
export const SUGGEST_WIDGET_URL = 'https://docs.google.com/forms/d/e/1FAIpQLScfxYgMeXdL2ZkD6WbnSOVS5kUOMvtuIlZgdguXFFiD57opYA/viewform';
const BILLING_HEALTH_CARDS = [
    'collection-rate',
    'anchor-vs-external',
    'avg-days-to-pay',
    'avg-invoice',
    'outstanding',
    'aging-breakdown'
];
const STATUS_CARDS = [
    'pending',
    'issued',
    'processing',
    'paid',
    'overdue',
    'voided',
    'refunded'
];
export const GetAddWidgetMenuTID = (parentTestId)=>getTestIds(parentTestId);
export const AddWidgetMenu = (param)=>{
    let { visibleCardIds, onAddCard, testId } = param;
    const { AddWidgetMenuTestIds } = useMemo(()=>GetAddWidgetMenuTID(testId), [
        testId
    ]);
    const { t: invoiceMetricsSectionTexts } = useLocaleKeys('components.invoiceMetricsSection');
    const { browser: { openNewTab } } = useIoContext();
    const visibleSet = useMemo(()=>new Set(visibleCardIds), [
        visibleCardIds
    ]);
    const cardTitle = (id)=>invoiceMetricsSectionTexts.cards[CARD_LOCALE_KEY[id]].title();
    const cardDescription = (id)=>invoiceMetricsSectionTexts.addWidgetMenu.cardDescriptions[CARD_LOCALE_KEY[id]]();
    const buildGroup = (groupId, label, availableCardIds)=>{
        if (availableCardIds.length === 0) return [];
        return [
            {
                id: groupId,
                isSectionHeader: true,
                label
            },
            ...availableCardIds.map((cardId)=>({
                    id: cardId,
                    title: cardTitle(cardId),
                    body: cardDescription(cardId),
                    bi: {
                        name: 'invoice_metrics_add_widget',
                        data: {
                            card_id: cardId
                        }
                    },
                    onClick: ()=>onAddCard(cardId)
                }))
        ];
    };
    const items = [
        ...buildGroup('group-billingHealth', invoiceMetricsSectionTexts.addWidgetMenu.billingHealthGroup(), BILLING_HEALTH_CARDS.filter((id)=>!visibleSet.has(id))),
        ...buildGroup('group-status', invoiceMetricsSectionTexts.addWidgetMenu.statusGroup(), STATUS_CARDS.filter((id)=>!visibleSet.has(id)))
    ];
    return /*#__PURE__*/ _jsx(Menu, {
        testId: AddWidgetMenuTestIds.Root(),
        items: items,
        emptyText: invoiceMetricsSectionTexts.addWidgetMenu.emptyState(),
        dimensions: {
            width: 360,
            maxHeight: 420
        },
        footer: {
            items: [
                {
                    variant: 'promotionalAction',
                    props: {
                        title: invoiceMetricsSectionTexts.addWidgetMenu.suggestWidget.title(),
                        body: invoiceMetricsSectionTexts.addWidgetMenu.suggestWidget.subtitle(),
                        onClick: ()=>openNewTab(SUGGEST_WIDGET_URL),
                        bi: {
                            name: 'invoice_metrics_suggest_widget'
                        }
                    }
                }
            ]
        }
    });
};
